module.exports = __webpack_public_path__ + "img/gift-3.01fe241d.jpg";